import {
  DELETE_VIDEO_FAIL,
  DELETE_VIDEO_SUCCESS,
  OPEN_VIDEO_FAIL,
  OPEN_VIDEO_SUCCESS,
  USER_LOGOUT,
  VIDEO_LIST_FAIL,
  VIDEO_LIST_REQUEST,
  VIDEO_LIST_SUCCESS,
} from "../contants/allConstants";

export const videoListReducer = (
  state = { videos: [], error: false, count_video: 0, loading: false },
  action
) => {
  switch (action.type) {
    case VIDEO_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        videos: [],
      };
    case VIDEO_LIST_SUCCESS: {
      const count_video = action.payload.videos.filter(
        (video) => video.openedBy.indexOf(action.payload.userId) === -1
      ).length;

      return {
        ...state,
        loading: false,
        videos: action.payload.videos,
        success: true,
        count_video,
      };
    }
    case VIDEO_LIST_FAIL:
      return {
        ...state,
        loading: false,
        success: true,
        videos: state.videos,
      };
    case DELETE_VIDEO_FAIL:
    // case OPEN_VIDEO_FAIL: {
    //   return { ...state, loading: false, error: action.payload };
    // }
    case DELETE_VIDEO_SUCCESS:
      const new_videos = state.videos.filter(
        (a) => a["_id"] !== action.payload
      );
      return {
        ...state,
        loading: false,
        success: true,
        videos: new_videos,
        count_video:0
      };
    case OPEN_VIDEO_SUCCESS:
      return {
        ...state,
        count_video: 0,
      };
    case USER_LOGOUT:
      return {
        loading: false,
        error: false,
        count_video: 0,
        videos: [],
      };
    default:
      return state;
  }
};
